<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble"><div class="pre" id="pre-002"><span epub:type="pagebreak" id="page_XII" title="XII"><div class="dev"><figure class="fig" id="fig-002"><div class="image"><img alt="The Ancient Mariner keeps watch at Watchet Harbour: like his mariner, Coleridge endured the agony of loneliness and despair, but also like him he survived the ordeal and was rewarded with a visionary experience of transﬁgured beauty in the world." class="image" src="images/pg_12_statue.jpg"/></div><figcaption class="leg"><p class="txt_courant_ssalinea">The Ancient Mariner keeps watch at Watchet Harbour: like his mariner, Coleridge endured the agony of loneliness and despair, but also like him he survived the ordeal and was rewarded with a visionary experience of transﬁgured beauty in the world.</p></figcaption></figure></div></span></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre3.vue?7543370a